export default __webpack_public_path__ + "static/media/marker-red-orange-yellow.63975339.png";